module.exports = __webpack_public_path__ + "static/web-scraper-1aec495b86f258f2c95783dba5ca7ece.png";